module.exports = __webpack_public_path__ + "static/media/M&MFIN.303a6151.txt";